import { Component, OnInit } from '@angular/core';

import { MenuItem } from 'primeng/api/menuitem';
import { MenuDataService } from 'src/app/services/menu-data.service';
@Component({
  selector: 'bart-part-manger-menu',
  templateUrl: './part-manger-menu.component.html',
  styleUrls: ['./part-manger-menu.component.scss']
})
export class PartMangerMenuComponent implements OnInit {
  items:  MenuItem[];
  constructor(private _menuService:MenuDataService) { }

  ngOnInit() {
    this.items=this._menuService.getPartMenuList();
    
  }

}
